export default __webpack_public_path__ + "static/partnerIcon14-d409a3a31771565aaef0dd63f3619aa7.svg";